<script lang="ts">
  import { tick } from "svelte";

  let {
    channel,
    noun = "task",
    ui = true,
    ts = null,
    class: className = "",
  }: {
    channel: string;
    noun?: string;
    ui?: boolean;
    ts?: number | null;
    class?: string;
  } = $props();

  const uid = $props.id();
  let div = $state<HTMLDivElement>();
  let button = $state<HTMLButtonElement>();
  let hidden = $state<string>("hidden");

  const inerted: HTMLElement[] = [];
  const makeInert = (container: Element) => {
    for (let el: Element = div; el !== container; el = el.parentElement) {
      for (const sib of el.parentElement.children) {
        if (sib === el || !(sib instanceof HTMLElement) || sib.inert || sib.matches("form[method=dialog]")) continue;
        sib.inert = true;
        inerted.push(sib);
      }
    }
  };
  const restoreInert = () => inerted.forEach((el) => (el.inert = false));

  const maskContainer = async () => {
    if (!ui) return;
    hidden = "";
    await tick();
    const container = div.closest<HTMLElement>(".modal-box") ?? (div.offsetParent as HTMLElement) ?? div.parentElement;
    const hadFocus = container.contains(document.activeElement);
    if (isScrollable(container)) {
      container.scrollTop = 0;
      container.style.overflow = "hidden";
    }
    makeInert(container);
    if (hadFocus) button.focus();
  };

  $effect(() => {
    const bc = new BroadcastChannel(channel);
    const closeChannel = () => bc.close();
    bc.onmessage = () => {
      closeChannel();
      maskContainer();
    };
    if (ts) bc.postMessage(ts);
    if (!ui) return closeChannel();
    return () => {
      closeChannel();
      restoreInert();
    };
  });

  const refresh = () => {
    const tframe = div.closest<Element & { reload(): void }>("turbo-frame[src]");
    (tframe || window.location).reload();
  };

  const isScrollable = (el: Element) =>
    ["auto", "scroll"].includes(getComputedStyle(el).overflowY) && el.scrollHeight > el.clientHeight;
</script>

{#if ui}
  <div
    bind:this={div}
    class="{hidden} {className} absolute top-0 bottom-0 left-0 right-0 bg-white/95 flex items-center justify-center">
    <div class="ui-rhythm text-center">
      <p id="{uid}-message" role="status" class="font-medium text-lg">
        You made progress on this {noun}<br />in another tab.
      </p>
      <p>
        <button bind:this={button} aria-describedby="{uid}-message" class="btn btn-primary" onclick={refresh}>
          Refresh
        </button>
      </p>
    </div>
  </div>
{/if}
